import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { DownloadSimple } from "@phosphor-icons/react";

export function DocPreviewDialog({ doc, open, onOpenChange }) {
  if (!doc) return null;
  const base = `${process.env.REACT_APP_BACKEND_URL}/api/documents/${doc.id}/file`;
  const mime = doc.mime_type || "";
  const isImage = mime.startsWith("image/");
  const isPdf = mime.includes("pdf");
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl" aria-describedby={undefined} data-testid="doc-preview-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading font-mono text-sm truncate pr-8">{doc.filename}</DialogTitle>
        </DialogHeader>
        <div className="rounded-md border border-zinc-200 bg-zinc-50 overflow-hidden max-h-[65vh]">
          {isImage ? (
            <img data-testid="doc-preview-image" src={base} alt={doc.filename} className="w-full max-h-[65vh] object-contain" />
          ) : isPdf ? (
            <iframe data-testid="doc-preview-iframe" src={base} title={doc.filename} className="w-full h-[65vh] bg-white" />
          ) : (
            <p className="text-xs text-zinc-500 p-8 text-center">No inline preview for this file type — use download.</p>
          )}
        </div>
        <div className="flex items-center justify-between">
          <p className="text-[10px] text-zinc-400">{doc.doc_type || "Unclassified"} · v{doc.version} · every preview & download is audit-logged</p>
          <a data-testid="doc-download-btn" href={`${base}?download=true`} target="_blank" rel="noreferrer">
            <Button size="sm" variant="outline" className="h-8 text-xs"><DownloadSimple size={14} className="mr-1" /> Download</Button>
          </a>
        </div>
      </DialogContent>
    </Dialog>
  );
}
